import { render } from "./MailForwards.vue?vue&type=template&id=7f5ec7c6&scoped=true"
import script from "./MailForwards.vue?vue&type=script&lang=js"
export * from "./MailForwards.vue?vue&type=script&lang=js"

import "./MailForwards.vue?vue&type=style&index=0&id=7f5ec7c6&lang=scss&scoped=true"

import exportComponent from "/home/ben/Projects/harborwall-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f5ec7c6"]])

export default __exports__